









































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { getQueryVariable } from "@/services/api"

interface paneitem {
  label: string;
  value: string;
  count:number;
}
const GreetingProps = Vue.extend({
  props: {
    tableData: Array,
    pageInfo: Object,
    flowDetailObj:Object,
    showTabs:String,
    totalClickCount:Number,
    totalUniqueClickCount:Number
  }
})
@Component({})
export default class wheelOfFortuneList extends GreetingProps {
  paneList: paneitem[]= []

  paneActiveName :string = getQueryVariable('activeTab') ? 'Orders' : 'Wait'

  emails :string = '';
  phones: string = '';

  flowDetail: any = {
    daterange:''
  };
  // showTabs:string =  'SendDetailed'
  sortObj: any = {order: null, prop: null}

  handShowTabs(val:string){
    this.$emit('handShowTabs',val)
  }

  handleEmailGo(item) {
    const flowId = location?.pathname?.split('/')[5]
    window.location.href = process.env.VUE_APP_DOMAIN + `/cartsee-new/userDetail?email=${item}&flowId=${flowId}&strategyChannel=${getQueryVariable('strategyChannel')}&cname=${getQueryVariable('cname')}&id=${getQueryVariable('id')}&type=flow&menu=false&navbar=false`
  }
  // 将邮箱地址的用户名部分进行掩码处理
  maskEmail(email) {
    const companyId = JSON.parse(localStorage.getItem('companyInfo')).id;
    // console.log(companyId, 'companyId');
  const targetCompany = [431, 459, 450, 461, 453, 472, 468, 470, 465, 457, 467, 469, 30];
  if (targetCompany.includes(companyId)) {
    let maskedEmail = "";
    const atIndex = email.indexOf("@");
    const name = email.substring(0, atIndex);
    const domain = email.substring(atIndex + 1);
    const maskedName = name.substring(0, 3) + "****";
    maskedEmail = maskedName + "@" + domain;
    return maskedEmail;
  } else {
    return email;
  }
  }

  created(): void {
    this.paneList = this.$route.query.strategyChannel === 'Sms'? [
      {label:this.$tx('flow.stats.waiting', '等待'),value:'Wait' ,count:0},
      {label:this.$tx('campaign.stats.send', '发送'),value:'Send',count:0},
      {label:this.$tx('flow.editor.metric.delivered', '送达'),value:'Delivery',count:0},
      {label:this.$tx('campaign.stats.filtered', '过滤'),value:'Filter',count:0},
      {label:this.$tx('campaign.stats.clicked', '点击'),value:'Click',count:0},
      {label:this.$tx('campaign.stats.placedOrder', '下单'),value:'Orders',count:0},
      {label:this.$tx('campaign.stats.bounce', '退回'),value:'Bounce',count:0},
      {label:this.$tx('campaign.stats.unsubscribed', '退订'),value:'Unsubscribe',count:0},
    ]:[
      {label:this.$tx('flow.stats.waiting', '等待'),value:'Wait' ,count:0},
      {label:this.$tx('campaign.stats.send', '发送'),value:'Send',count:0},
      {label:this.$tx('campaign.stats.filtered', '过滤'),value:'Filter',count:0},
      {label:this.$tx('campaign.stats.opened', '打开'),value:'Open',count:0},
      {label:this.$tx('campaign.stats.clicked', '点击'),value:'Click',count:0},
      {label:this.$tx('campaign.stats.placedOrder', '下单'),value:'Orders',count:0},
      {label:this.$tx('campaign.stats.bounce', '退回'),value:'Bounce',count:0},
      {label:this.$tx('campaign.stats.unsubscribed', '退订'),value:'Unsubscribe',count:0},
      {label:this.$tx('campaign.stats.complained', '投诉'),value:'Complaint',count:0},
    ]
    // this.getWheelOfFortuneList();
  }
  mounted() {
    getQueryVariable('activeTab') ? this.handleClick({ name: 'Orders'}) : this.handleClick({ name: 'Wait'})
  }
  clickURL(val:string){
    window.open(val)
  }
  //
  getColumn( val?:string, isShow?:boolean,val2?:string){
    if (val || val2) {
      if (val === this.paneActiveName ||val2 === this.paneActiveName) {
        return isShow
      }else{
        return !isShow
      }
    }else{
      if (this.paneActiveName === 'Wait' || this.paneActiveName === 'Filter' || this.paneActiveName === 'Bounce') {
        return false
      }
    }
    return true
  }

  handleClick(vm:any,event:string){
    this.$refs.multipleTable?.clearSort()
    this.emails = '';
    this.phones = '';
    this.$emit('handleClick',vm.name)
  }

  getclass(scope:any){return '__status--' + { 0:'suspend',1 :'running'}[scope.row.status as 1 | 0]}
  gettaskStatus(scope:any) {return {
    WaitSend: this.$tx('campaign.list.status.scheduled', '待发送'),
    Delivered: this.$tx('campaign.stats.sent', '已发送'),
    Bounce: this.$tx('campaign.stats.bounce', '退回'),
    ConditionFilter:this.$tx('campaign.stats.conditionFilter', '条件过滤'),
    BlackListFilter:this.$tx('campaign.stats.blocklistFilter', '黑名单过滤'),
    IntelligentSendFilter: this.$tx('campaign.stats.smartSending', '智能过滤'),
    DisableFilter: this.$tx('flow.stats.disabledUserFilter', '禁用用户过滤')
    }[scope as 'WaitSend'|"Delivered"|'Bounce'|"ConditionFilter"|"BlackListFilter"| 'IntelligentSendFilter' | 'DisableFilter']}

  //显示空值
  formatterChangeNUll(r:any, c:any, v:any){return  v === 0?'$0':(`$${v}` || '-')}

  formatterChange(r:any, c:any, v:any) {return v === 0?0:(v || '-')}

  sortChange(data:any){
    this.sortObj = {order: data?.order, prop: data?.prop}
    this.$emit('sortChange',data)
  }

  goOrderUrl(e:string){
    window.open(e)
  }

  changeEmail(e:string){
    this.$emit('changeEmail',e)
  }

  changePhone(e:string){
    this.$emit('changePhone',e)
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.$emit('handleSizeChange',val)
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.$emit('handleCurrentChange', val)
  }
  @Watch("flowDetailObj")
  changFlowDetailObj(oldval: any, newval: any){
    let n = this.$props.flowDetailObj
    this.paneList = this.$route.query.strategyChannel === 'Sms'? [
      {label:this.$tx('flow.stats.waiting', '等待'),value:'Wait' ,count:n.waitCount},
      {label:this.$tx('campaign.stats.send', '发送'),value:'Send',count: n.sendCount},
      {label:this.$tx('flow.editor.metric.delivered', '送达'),value:'Delivery',count:n.deliveryCount},
      {label:this.$tx('campaign.stats.filtered', '过滤'),value:'Filter',count:n.filterCount},
      {label:this.$tx('campaign.stats.clicked', '点击'),value:'Click',count: n.clickCount},
      {label:this.$tx('campaign.stats.placedOrder', '下单'),value:'Orders',count: n.orderDetailCount},
      {label:this.$tx('campaign.stats.bounce', '退回'),value:'Bounce',count:n.bounceCount},
      {label:this.$tx('campaign.stats.unsubscribed', '退订'),value:'Unsubscribe',count:n.unsubscribeCount},
    ]: [
      {label:this.$tx('flow.stats.waiting', '等待'),value:'Wait' ,count: n.waitCount},
      {label:this.$tx('campaign.stats.send', '发送'),value:'Send',count: n.sendCount},
      {label:this.$tx('campaign.stats.filtered', '过滤'),value:'Filter',count: n.filterCount},
      {label:this.$tx('campaign.stats.opened', '打开'),value:'Open',count: n.openCount},
      {label:this.$tx('campaign.stats.clicked', '点击'),value:'Click',count: n.clickCount},
      {label:this.$tx('campaign.stats.placedOrder', '下单'),value:'Orders',count: n.orderDetailCount},
      {label:this.$tx('campaign.stats.bounce', '退回'),value:'Bounce',count:n.bounceCount},
      {label:this.$tx('campaign.stats.unsubscribed', '退订'),value:'Unsubscribe',count:n.unsubscribeCount},
      {label:this.$tx('campaign.stats.complained', '投诉'),value:'Complaint',count:n.complaintCount},
    ]
  }
}
